import { render, staticRenderFns } from "./AppliedJobOpeningCard.vue?vue&type=template&id=630828b8&scoped=true&"
import script from "./AppliedJobOpeningCard.vue?vue&type=script&lang=js&"
export * from "./AppliedJobOpeningCard.vue?vue&type=script&lang=js&"
import style0 from "./AppliedJobOpeningCard.vue?vue&type=style&index=0&id=630828b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630828b8",
  null
  
)

export default component.exports